export default {
  methods: {
    saveForLater: async function (workId, medium) {
      await this.$axios.post("/saved-for-later", {
        medium,
        internal_id: workId,
      });
      // Used to update cached search if needed
      this.$store.commit("updateSavedForLater", {
        medium,
        internal_id: workId,
        value: true, // Says that is has been watchlisted
      });
      return true;
    },
    removeFromWatchlist: async function (workId, medium, idIsExternal) {
      const response = await this.$axios.delete("/saved-for-later", {
        params: {
          medium,
          workId,
          idIsExternal,
        },
      });
      if (response.data < 1) {
        throw new Error("No entries deleted");
      }
      this.$store.commit("updateSavedForLater", {
        medium,
        internal_id: workId,
        value: false, // Says that is has been watchlisted
      });
      return true;
    },
    markAsViewed: async function (workId, medium) {
      await this.$axios.post("/works_viewed", {
        medium,
        internal_id: workId,
      });
      this.$store.commit("updateSeen", {
        medium,
        workId,
        value: true,
      });
      return true;
    },
    deleteFromViewed: async function (workId, medium) {
      await this.$axios.delete("/works_viewed", {
        params: {
          internal_id: workId,
          medium,
        },
      });
      this.$store.commit("updateSeen", {
        medium,
        workId,
        value: false,
      });
      return true;
    },
  },
};
